// extracted by css-extract-rspack-plugin
module.exports =  {"columns":"General__columns___Cx5Yf","column":"General__column___EEeVn"};